// import store from "@/store"

const shouldUseNewVisitModal = () => {
    return true
    // return [1843, 8636].includes(store.state.auth.clinic?.id)
    // return [184300].includes(store.state.auth.clinic?.id)
}

export { shouldUseNewVisitModal }
